/**
 * Missing values are `null` or `undefined`
 */ /**
 * Check if a value is considered to represent a missing value, which means that it is `null` or `undefined`.
 *
 * @param value The value to check.
 * @returns Whether the value is `null` or `undefined`.
 */ export var isMissingValue = function isMissingValue(value) {
    return value === null || value === undefined;
};

//# sourceMappingURL=Missing.js.map